import urls from "global/constants/UrlConstants";
import { ExpiryPwdUser } from "models/interfaces";
import { getCallParams, makeCall } from "utils/service";

export const updateAutoEmailReminder = async (autoReminder: boolean) => {
  const payload = {
    value: autoReminder,
  };
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(
      urls.UPDATE_AUTO_EMAIL_REMINDER_CONFIGURATION,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAutoEmailReminder = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GET_AUTO_EMAIL_REMINDER_CONFIGURATION,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateAutoReminderConfig = async (
  daysBeforeFirstReminder: number,
  daysBetweenReminders: number
) => {
  const payload = {
    value: JSON.stringify({
      daysBeforeFirstReminder: daysBeforeFirstReminder,
      daysBetweenReminders: daysBetweenReminders,
    }),
  };
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(
      urls.UPDATE_AUTO_REMINDER_CONFIGURATION,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAutoReminderConfig = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GET_AUTO_REMINDER_CONFIGURATION,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateExpirationDays = async (expirationDays: number) => {
  const payload = {
    value: expirationDays,
  };
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(
      urls.UPDATE_EXPIRATION_DAYS_CONFIGURATION,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getExpirationDays = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GET_EXPIRATION_DAYS_CONFIGURATION,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateExpiryPassword = async (
  pwdExpiryEnable: boolean,
  expirationPassword: number
) => {
  const payload = {
    value: JSON.stringify({
      pwdExpiryEnable: pwdExpiryEnable,
      pwdExpiryRemainingDays: expirationPassword,
    }),
  };
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.UPDATE_EXPIRY_PASSWORD, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getExpiryPassword = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GET_EXPIRY_PASSWORD, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const expiryUpdatePwd = async (
  user: ExpiryPwdUser,
  signOutOtherDevices?: boolean,
  checkOldPwd?: boolean
) => {
  try {
    const callParams = await getCallParams("POST", user);
    const params = new URLSearchParams();

    if (checkOldPwd !== undefined) {
      params.append(
        "checkOldPwd",
        String(checkOldPwd)
      );
    }

    if (signOutOtherDevices !== undefined) {
      params.append("logoutAllSessions", String(signOutOtherDevices));
    }
    const response: any = await makeCall(
      `${urls.EXPIRY_UPDATE_PASSWORD}${
        params.toString() ? `?${params.toString()}` : ""
      }`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const notExpiryUpdatePwd = async (
  user: ExpiryPwdUser,
  signOutOtherDevices?: boolean,
) => {
  try {
    const callParams = await getCallParams("POST", user);
    const params = new URLSearchParams();

    if (signOutOtherDevices !== undefined) {
      params.append("logoutAllSessions", String(signOutOtherDevices));
    }
    const response: any = await makeCall(
      `${urls.NOT_EXPIRY_UPDATE_PASSWORD}${
        params.toString() ? `?${params.toString()}` : ""
      }`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};
